import cn from 'classnames'

import { Translation } from 'cng-common/features/translations/components/translation'

import {
  KEY_INITIATIVES_STEP_DESC_SUFFIX,
  KEY_INITIATIVES_STEP_LABEL_SUFFIX,
  TMenuStepWithStatus,
} from '../../config'

import styles from './KeyInitiativeStepsMenu.module.scss'

type Props = {
  steps: TMenuStepWithStatus[]
  disabledSteps?: Set<number>
  stepsWithErrors?: Set<number>
  onSelect: (stepIndex: number) => void
}

export const KeyInitiativeStepsMenu = ({
  steps,
  disabledSteps,
  stepsWithErrors,
  onSelect,
}: Props) => {
  return (
    <nav className={styles.menu} aria-label="Key Initiative sections">
      {steps.map((step, index) => {
        const isDisabled = disabledSteps?.has(index)
        const hasError = stepsWithErrors?.has(index)

        return (
          <button
            key={step.key}
            type="button"
            className={cn(styles.menuItem, styles[step.status], {
              [styles.disabled]: isDisabled,
              [styles.hasError]: hasError,
            })}
            onClick={() => onSelect(index)}
            disabled={isDisabled}
          >
            <span className={styles.menuBody}>
              <span className={styles.menuLabel}>
                <Translation text={`${step.key}${KEY_INITIATIVES_STEP_LABEL_SUFFIX}`} span />
              </span>
              <span className={styles.menuDescription}>
                <Translation text={`${step.key}${KEY_INITIATIVES_STEP_DESC_SUFFIX}`} span />
              </span>
            </span>
          </button>
        )
      })}
    </nav>
  )
}
